import type {ScheduleItem} from '@domain/schedule'
import {roundTo15MinIntervalStart} from '@hconnect/common/utils'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {PowerOutlined} from '@mui/icons-material'
import {Stack, Typography} from '@mui/material'
import {useCurrentTimeRounded} from '@widgets/stock-card'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {PlannerSwitch} from '../formComponents'

interface ScheduleItemShutdownAvailabilitySwitchProps {
  scheduleItem: ScheduleItem
  handleShutdownAvailabilityChange: (isShutdownAvailable: boolean) => void
}
export const ScheduleItemShutdownAvailabilitySwitch: React.FC<
  ScheduleItemShutdownAvailabilitySwitchProps
> = ({scheduleItem, handleShutdownAvailabilityChange}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezoneId = useUpmPlantTimezone()
  const nowRounded = useCurrentTimeRounded({timezoneId, roundingFn: roundTo15MinIntervalStart})
  const isDisabled = moment.utc(scheduleItem.end).isBefore(nowRounded)

  const onChange = (isChecked: boolean) => handleShutdownAvailabilityChange(isChecked)

  return (
    <PlannerSwitch
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <PowerOutlined />
          <Typography>{t('planning.assetShutdownAvailability')}</Typography>
        </Stack>
      }
      value={scheduleItem.isShutdownAvailable}
      onChange={onChange}
      disabled={isDisabled}
      {...dataTestId('asset_shutdown_availability')}
    />
  )
}
